"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailFieldValueGetter = void 0;
const safe_field_value_1 = require("../../safe-field-value");
const email_1 = require("../../type-checking/email");
class EmailFieldValueGetter extends safe_field_value_1.BaseFieldValueGetter {
    constructor() {
        super(...arguments);
        this.isValidFieldValue = (fieldValue) => {
            return (0, email_1.isEmailFieldValue)(fieldValue);
        };
        this.getEmptyValue = () => [];
    }
}
exports.EmailFieldValueGetter = EmailFieldValueGetter;
